const nrml = s =>
  s
    .toLowerCase()
    .trim()
    .replace(/[\W]/, ' ')

export default (a, b) => nrml(a) === nrml(b)
